<template>
    
    <b-navbar class="shadow sticky top-0" :mobile-burger="true">
        <template #brand>
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img
                    src="https://myedubbosz01.s3.eu-central-1.amazonaws.com/logo_Edu_trans_dda26c22e7.png"
                    alt="Lightweight UI components for Vue.js based on Bulma"
                >
            </b-navbar-item>
        </template>
        <template #start>
            <b-navbar-item href="/documentation">
                Documentation
            </b-navbar-item>
            <b-navbar-item href="/courses">
                Kurse
            </b-navbar-item>
            <b-navbar-item v-if="user.role.name == 2" href="/onboarding">
                Tutorial
            </b-navbar-item>
            <b-navbar-item href="/seminars">
              Workshops
            </b-navbar-item>
            <b-navbar-item href="/webinar">
              Webinare
            </b-navbar-item>
             <b-navbar-dropdown label="Info">
                <b-navbar-item href="/about">
                    Impressum
                </b-navbar-item>
                <b-navbar-item href="https://myedubbosz01.s3.eu-central-1.amazonaws.com/AGB_Portal_Kompetenznetzwerk_5dfd73114c.pdf">
                    AGB
                </b-navbar-item>
            </b-navbar-dropdown> 
        </template>

        <template #end>
            
                    <router-link to="/register" >
                        <div v-if="user.role.name > 0">
                        </div>
                        <div v-else>
                          <div class="buttons py-1 px-1">
                            <b-button type="is-primary" expanded>Registrieren</b-button>
                        </div>

                        </div>
                    </router-link>
                    
                    <div 
                    v-if="user.role.name > 0"
                    class="buttons mr-5 is-mobile sm:py-0 py-2 justify-center text-center"
                    >
                      <p>Eingeloggt als: {{user.firstName}}</p>
                    </div>
                    <br />
                    <div v-if="user.role.name > 0">
                      <div class="buttons py-1 px-1">
                            <b-button type="is-danger" v-on:click="logout" expanded>Abmelden</b-button>
                        </div>
                        <!-- <a class="button is-danger" v-on:click="logout">Abmelden</a> -->
                    </div>
                    <div v-else>
                        <router-link to="/login" >
                          <div class="buttons py-1 px-1">
                            <b-button type="is-light" expanded>Login</b-button>
                        </div>
                    </router-link>
                </div>
              
        </template>
     
    </b-navbar>
</template>

<script>

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faGraduationCap,
  faUser,
  faChalkboard,
  faChalkboardTeacher,
  faSignIn,
  faSignOut,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faHome,
  faGraduationCap,
  faUser,
  faChalkboard,
  faChalkboardTeacher,
  faSignIn,
  faSignOut
);

export default { 
    name: "NavBarTop",
    data: function() {
      return {
        menu: false,
        routes: this.$router.options.routes,
        user: JSON.parse(localStorage.getItem("user"))
          ? JSON.parse(localStorage.getItem("user"))
          : { role: { name: 0 } },
        logoutIcon: "fas fa-sign-out",
      };
    },
    methods: {
      // startLogoutTimer() {
      //   if(this.user.role.name > 0){
      //     const logoutTime = 10 * 60 * 1000; // 10 minutes in milliseconds
      //     setTimeout(this.logout, logoutTime);
      //   }
      // },
      isCurrentPath(path) {
        if (path === this.$router.history.current.path) return true;
        else return false;
      },
      async logout() {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        this.$router.go("/");
      },
    },
    mounted(){
      //this.startLogoutTimer();
    },
    computed: {
      navRoutes: function() {
        return this.routes.filter((route) => {
          return route.inNav;
        });
      },
    },
  };
  </script>
  
  <style scoped>
  @import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
  </style>
  